// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation__sidebar {
  flex: 0 0 256px;
  background-color: var(--g-color-base-generic-ultralight);
}
.dl-core-navigation__content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background-color: var(--g-color-base-background);
}
.dl-core-navigation__entries {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  overflow: hidden;
}
.dl-core-navigation__entries-header {
  flex: 0 0 auto;
  padding: 0 20px 8px;
  display: flex;
}
.dl-core-navigation__search {
  flex: 0 1 400px;
  margin-right: 8px;
}
.dl-core-navigation__custom {
  margin-left: auto;
  padding-left: 8px;
}
.dl-core-navigation__custom:empty {
  display: none;
}
.dl-core-navigation__custom:not(:empty) {
  display: flex;
}
.dl-core-navigation__view {
  flex: 1 1 100%;
}
.dl-core-navigation__table-view {
  height: 100%;
}
.dl-core-navigation__spinner {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dl-core-navigation__empty-entries {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dl-core-navigation__filters {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.dl-core-navigation__filters-item {
  margin-right: 8px;
}
.dl-core-navigation__filters-item:last-of-type {
  margin-right: 0;
}
.dl-core-navigation__mobile-filters {
  padding: 21px 23px;
  display: flex;
}
.dl-core-navigation__mobile-filters_mobile {
  padding: 8px 16px 19px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/NavigationEntries.scss"],"names":[],"mappings":"AAGI;EACI,eAAA;EACA,wDAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gDAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAJR;AAOI;EACI,cAAA;EACA,mBAAA;EACA,aAAA;AALR;AAQI;EACI,eAAA;EACA,iBAAA;AANR;AASI;EACI,iBAAA;EACA,iBAAA;AAPR;AASQ;EACI,aAAA;AAPZ;AASQ;EACI,aAAA;AAPZ;AAWI;EACI,cAAA;AATR;AAYI;EACI,YAAA;AAVR;AAaI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXR;AAcI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZR;AAeI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AAbR;AAgBI;EACI,iBAAA;AAdR;AAgBQ;EACI,eAAA;AAdZ;AAkBI;EACI,kBAAA;EACA,aAAA;AAhBR;AAkBQ;EACI,sBAAA;EACA,cAAA;AAhBZ","sourcesContent":[".dl-core-navigation__sidebar {\n  flex: 0 0 256px;\n  background-color: var(--g-color-base-generic-ultralight);\n}\n.dl-core-navigation__content {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  background-color: var(--g-color-base-background);\n}\n.dl-core-navigation__entries {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 100%;\n  overflow: hidden;\n}\n.dl-core-navigation__entries-header {\n  flex: 0 0 auto;\n  padding: 0 20px 8px;\n  display: flex;\n}\n.dl-core-navigation__search {\n  flex: 0 1 400px;\n  margin-right: 8px;\n}\n.dl-core-navigation__custom {\n  margin-left: auto;\n  padding-left: 8px;\n}\n.dl-core-navigation__custom:empty {\n  display: none;\n}\n.dl-core-navigation__custom:not(:empty) {\n  display: flex;\n}\n.dl-core-navigation__view {\n  flex: 1 1 100%;\n}\n.dl-core-navigation__table-view {\n  height: 100%;\n}\n.dl-core-navigation__spinner {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.dl-core-navigation__empty-entries {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dl-core-navigation__filters {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.dl-core-navigation__filters-item {\n  margin-right: 8px;\n}\n.dl-core-navigation__filters-item:last-of-type {\n  margin-right: 0;\n}\n.dl-core-navigation__mobile-filters {\n  padding: 21px 23px;\n  display: flex;\n}\n.dl-core-navigation__mobile-filters_mobile {\n  padding: 8px 16px 19px;\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
